{
  "CONTACT_PANEL": {
    "NOT_AVAILABLE": "Nedostupné",
    "EMAIL_ADDRESS": "E-mailová adresa",
    "PHONE_NUMBER": "Telefonní číslo",
    "IDENTIFIER": "Identifikátor",
    "COPY_SUCCESSFUL": "Úspěšně zkopírováno do schránky",
    "COMPANY": "Společnost",
    "LOCATION": "Poloha",
    "BROWSER_LANGUAGE": "Browser Language",
    "CONVERSATION_TITLE": "Podrobnosti konverzace",
    "VIEW_PROFILE": "View Profile",
    "BROWSER": "Prohlížeč",
    "OS": "Operační systém",
    "INITIATED_FROM": "Zahájeno od",
    "INITIATED_AT": "Zahájeno v",
    "IP_ADDRESS": "IP adresa",
    "CREATED_AT_LABEL": "Created",
    "NEW_MESSAGE": "New message",
    "CALL": "Call",
    "CALL_INITIATED": "Calling the contact…",
    "CALL_FAILED": "Unable to start the call. Please try again.",
    "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
    "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
    "CLICK_TO_EDIT": "Click to edit",
    "VOICE_INBOX_PICKER": {
      "TITLE": "Choose a voice inbox"
    },
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "K tomuto kontaktu nejsou přiřazeny žádné předchozí konverzace.",
      "TITLE": "Předchozí konverzace"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "Contact Labels",
        "ERROR": "Couldn't update labels"
      },
      "CONVERSATION": {
        "TITLE": "Conversation Labels",
        "ADD_BUTTON": "Add Labels"
      },
      "LABEL_SELECT": {
        "TITLE": "Add Labels",
        "PLACEHOLDER": "Search labels",
        "NO_RESULT": "No labels found",
        "CREATE_LABEL": "Create new label"
      }
    },
    "MERGE_CONTACT": "Merge contact",
    "CONTACT_ACTIONS": "Contact actions",
    "MUTE_CONTACT": "Block Contact",
    "UNMUTE_CONTACT": "Unblock Contact",
    "MUTED_SUCCESS": "This contact is blocked successfully. You will not be notified of any future conversations.",
    "UNMUTED_SUCCESS": "This contact is unblocked successfully.",
    "SEND_TRANSCRIPT": "Poslat přepis",
    "EDIT_LABEL": "Upravit",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "Vlastní atributy",
      "CONTACT_LABELS": "Contact Labels",
      "PREVIOUS_CONVERSATIONS": "Předchozí konverzace",
      "NO_RECORDS_FOUND": "Nebyly nalezeny žádné atributy"
    }
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "Upravit kontakt",
    "TITLE": "Upravit kontakt",
    "DESC": "Upravit kontaktní údaje"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "Delete Contact",
    "TITLE": "Delete contact",
    "DESC": "Delete contact details",
    "CONFIRM": {
      "TITLE": "Potvrdit odstranění",
      "MESSAGE": "Opravdu chcete odstranit ",
      "YES": "Ano, odstranit",
      "NO": "Ne, zachovat"
    },
    "API": {
      "SUCCESS_MESSAGE": "Contact deleted successfully",
      "ERROR_MESSAGE": "Could not delete contact. Please try again later."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "Odeslat",
      "CANCEL": "Zrušit",
      "AVATAR": {
        "LABEL": "Avatar kontaktu"
      },
      "NAME": {
        "PLACEHOLDER": "Zadejte celé jméno kontaktu",
        "LABEL": "Celé jméno"
      },
      "BIO": {
        "PLACEHOLDER": "Zadejte bio kontaktu",
        "LABEL": "Bio"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "Zadejte e-mailovou adresu kontaktu",
        "LABEL": "E-mailová adresa",
        "DUPLICATE": "Tuto e-mailovou adresu již používá jiný kontakt.",
        "ERROR": "Zadejte prosím platnou e-mailovou adresu."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "Zadejte telefonní číslo kontaktu",
        "LABEL": "Telefonní číslo",
        "HELP": "Phone number should be of E.164 format eg: +1415555555 [+][country code][area code][local phone number]",
        "ERROR": "Phone number should be either empty or of E.164 format",
        "DIAL_CODE_ERROR": "Please select a dial code from the list",
        "DUPLICATE": "This phone number is in use for another contact."
      },
      "LOCATION": {
        "PLACEHOLDER": "Zadejte lokaci kontaktu",
        "LABEL": "Poloha"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "Zadejte název společnosti",
        "LABEL": "Název společnosti"
      },
      "COUNTRY": {
        "PLACEHOLDER": "Enter the country name",
        "LABEL": "Country Name",
        "SELECT_PLACEHOLDER": "Select",
        "REMOVE": "Odebrat",
        "SELECT_COUNTRY": "Select Country"
      },
      "CITY": {
        "PLACEHOLDER": "Enter the city name",
        "LABEL": "City Name"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "Zadejte uživatelské jméno na Facebooku",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "Zadejte uživatelské jméno na Twitteru",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "Zadejte uživatelské jméno na LinkedInu",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "Zadejte uživatelské jméno na GitHubu",
          "LABEL": "GitHub"
        }
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "Contact avatar deleted successfully",
        "ERROR_MESSAGE": "Could not delete the contact avatar. Please try again later."
      }
    },
    "SUCCESS_MESSAGE": "Kontakt byl úspěšně uložen",
    "ERROR_MESSAGE": "Došlo k chybě, zkuste to prosím znovu"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "Start conversation",
    "TITLE": "Nová konverzace",
    "DESC": "Start a new conversation by sending a new message.",
    "NO_INBOX": "Couldn't find an inbox to initiate a new conversation with this contact.",
    "FORM": {
      "TO": {
        "LABEL": "To"
      },
      "INBOX": {
        "LABEL": "Inbox",
        "PLACEHOLDER": "Choose source inbox",
        "ERROR": "Select an inbox"
      },
      "SUBJECT": {
        "LABEL": "Předmět",
        "PLACEHOLDER": "Předmět",
        "ERROR": "Subject can't be empty"
      },
      "MESSAGE": {
        "LABEL": "Zpráva",
        "PLACEHOLDER": "Write your message here",
        "ERROR": "Message can't be empty"
      },
      "ATTACHMENTS": {
        "SELECT": "Choose files",
        "HELP_TEXT": "Drag and drop files here or choose files to attach"
      },
      "SUBMIT": "Send message",
      "CANCEL": "Zrušit",
      "SUCCESS_MESSAGE": "Message sent!",
      "GO_TO_CONVERSATION": "Zobrazit",
      "ERROR_MESSAGE": "Couldn't send! try again"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "Sociální profily"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "Add custom attribute",
    "COPY_SUCCESSFUL": "Úspěšně zkopírováno do schránky",
    "SHOW_MORE": "Show all attributes",
    "SHOW_LESS": "Show less attributes",
    "ACTIONS": {
      "COPY": "Copy attribute",
      "DELETE": "Delete attribute",
      "EDIT": "Edit attribute"
    },
    "ADD": {
      "TITLE": "Create custom attribute",
      "DESC": "Add custom information to this contact."
    },
    "FORM": {
      "CREATE": "Add attribute",
      "CANCEL": "Zrušit",
      "NAME": {
        "LABEL": "Custom attribute name",
        "PLACEHOLDER": "Eg: shopify id",
        "ERROR": "Invalid custom attribute name"
      },
      "VALUE": {
        "LABEL": "Attribute value",
        "PLACEHOLDER": "Eg: 11901 "
      },
      "ADD": {
        "TITLE": "Create new attribute ",
        "SUCCESS": "Attribute added successfully",
        "ERROR": "Unable to add attribute. Please try again later"
      },
      "UPDATE": {
        "SUCCESS": "Attribute updated successfully",
        "ERROR": "Unable to update attribute. Please try again later"
      },
      "DELETE": {
        "SUCCESS": "Attribute deleted successfully",
        "ERROR": "Unable to delete attribute. Please try again later"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "Add attributes",
        "PLACEHOLDER": "Search attributes",
        "NO_RESULT": "No attributes found"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "Select value",
          "SEARCH_INPUT_PLACEHOLDER": "Search value",
          "NO_RESULT": "No result found"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "Valid value is required",
      "INVALID_URL": "Invalid URL",
      "INVALID_INPUT": "Invalid Input"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "Merge contacts",
    "DESCRIPTION": "Merge contacts to combine two profiles into one, including all attributes and conversations. In case of conflict, the Primary contact’ s attributes will take precedence.",
    "PRIMARY": {
      "TITLE": "Primary contact",
      "HELP_LABEL": "To be deleted"
    },
    "PARENT": {
      "TITLE": "Contact to merge",
      "PLACEHOLDER": "Search for a contact",
      "HELP_LABEL": "To be kept"
    },
    "SUMMARY": {
      "TITLE": "Summary",
      "DELETE_WARNING": "Contact of <strong>{primaryContactName}</strong> will be deleted.",
      "ATTRIBUTE_WARNING": "Contact details of <strong>{primaryContactName}</strong> will be copied to <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "Something went wrong. Please try again later."
    },
    "FORM": {
      "SUBMIT": " Merge contacts",
      "CANCEL": "Zrušit",
      "CHILD_CONTACT": {
        "ERROR": "Select a child contact to merge"
      },
      "SUCCESS_MESSAGE": "Contact merged successfully",
      "ERROR_MESSAGE": "Could not merge contacts, try again!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(ID: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "Kontakty",
      "SEARCH_TITLE": "Search contacts",
      "ACTIVE_TITLE": "Active contacts",
      "SEARCH_PLACEHOLDER": "Search...",
      "MESSAGE_BUTTON": "Zpráva",
      "SEND_MESSAGE": "Send message",
      "BLOCK_CONTACT": "Block contact",
      "UNBLOCK_CONTACT": "Unblock contact",
      "BREADCRUMB": {
        "CONTACTS": "Kontakty"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "Add contact",
          "EXPORT_CONTACT": "Export contacts",
          "IMPORT_CONTACT": "Import contacts",
          "SAVE_CONTACT": "Save contact",
          "EMAIL_ADDRESS_DUPLICATE": "Tuto e-mailovou adresu již používá jiný kontakt.",
          "PHONE_NUMBER_DUPLICATE": "This phone number is in use for another contact.",
          "SUCCESS_MESSAGE": "Kontakt byl úspěšně uložen",
          "ERROR_MESSAGE": "Unable to save contact. Please try again later."
        },
        "BLOCK_SUCCESS_MESSAGE": "This contact is blocked successfully",
        "BLOCK_ERROR_MESSAGE": "Unable to block contact. Please try again later.",
        "UNBLOCK_SUCCESS_MESSAGE": "This contact is unblocked successfully",
        "UNBLOCK_ERROR_MESSAGE": "Unable to unblock contact. Please try again later.",
        "IMPORT_CONTACT": {
          "TITLE": "Import contacts",
          "DESCRIPTION": "Import contacts through a CSV file.",
          "DOWNLOAD_LABEL": "Download a sample csv.",
          "LABEL": "CSV File:",
          "CHOOSE_FILE": "Choose file",
          "CHANGE": "Změnit",
          "CANCEL": "Zrušit",
          "IMPORT": "Import",
          "SUCCESS_MESSAGE": "You will be notified via email when the import is complete.",
          "ERROR_MESSAGE": "Došlo k chybě, zkuste to prosím znovu"
        },
        "EXPORT_CONTACT": {
          "TITLE": "Export contacts",
          "DESCRIPTION": "Quickly export a csv file with comprehensive details of your contacts",
          "CONFIRM": "Export",
          "SUCCESS_MESSAGE": "Export is in progress, You will be notified via email when export file is ready to dowanlod.",
          "ERROR_MESSAGE": "Došlo k chybě, zkuste to prosím znovu"
        },
        "SORT_BY": {
          "LABEL": "Seřadit podle",
          "OPTIONS": {
            "NAME": "Název",
            "EMAIL": "E-mailová adresa",
            "PHONE_NUMBER": "Telefonní číslo",
            "COMPANY": "Společnost",
            "COUNTRY": "Země",
            "CITY": "Město",
            "LAST_ACTIVITY": "Poslední aktivita",
            "CREATED_AT": "Vytvořeno"
          }
        },
        "ORDER": {
          "LABEL": "Ordering",
          "OPTIONS": {
            "ASCENDING": "Ascending",
            "DESCENDING": "Descending"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "Do you want to save this filter?",
            "CONFIRM": "Save filter",
            "LABEL": "Název",
            "PLACEHOLDER": "Enter the name of the filter",
            "ERROR": "Enter a valid name",
            "SUCCESS_MESSAGE": "Filter saved successfully",
            "ERROR_MESSAGE": "Unable to save filter. Please try again later."
          },
          "DELETE_SEGMENT": {
            "TITLE": "Potvrdit odstranění",
            "DESCRIPTION": "Are you sure you want to delete this filter?",
            "CONFIRM": "Ano, odstranit",
            "CANCEL": "No, Cancel",
            "SUCCESS_MESSAGE": "Filter deleted successfully",
            "ERROR_MESSAGE": "Unable to delete filter. Please try again later."
          }
        }
      }
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "Showing {startItem} - {endItem} of {totalItems} contacts"
    },
    "FILTER": {
      "NAME": "Název",
      "EMAIL": "E-mailová adresa",
      "PHONE_NUMBER": "Telefonní číslo",
      "IDENTIFIER": "Identifikátor",
      "COUNTRY": "Země",
      "CITY": "Město",
      "COMPANY": "Společnost",
      "CREATED_AT": "Vytvořeno",
      "LAST_ACTIVITY": "Poslední aktivita",
      "REFERER_LINK": "Referer link",
      "BLOCKED": "Blocked",
      "BLOCKED_TRUE": "True",
      "BLOCKED_FALSE": "False",
      "BUTTONS": {
        "CLEAR_FILTERS": "Clear filters",
        "UPDATE_SEGMENT": "Update segment",
        "APPLY_FILTERS": "Apply filters",
        "ADD_FILTER": "Add filter"
      },
      "TITLE": "Filtrovat kontakty",
      "EDIT_SEGMENT": "Edit segment",
      "SEGMENT": {
        "LABEL": "Segment name",
        "INPUT_PLACEHOLDER": "Enter the name of the segment"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ {count} more filters",
        "CLEAR_FILTERS": "Clear filters"
      }
    },
    "CARD": {
      "OF": "of",
      "VIEW_DETAILS": "Zobrazit detaily",
      "EDIT_DETAILS_FORM": {
        "TITLE": "Upravit kontaktní údaje",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "Enter the first name"
          },
          "LAST_NAME": {
            "PLACEHOLDER": "Enter the last name"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "Enter the email address",
            "DUPLICATE": "Tuto e-mailovou adresu již používá jiný kontakt."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "Enter the phone number",
            "DUPLICATE": "This phone number is in use for another contact."
          },
          "CITY": {
            "PLACEHOLDER": "Enter the city name"
          },
          "COUNTRY": {
            "PLACEHOLDER": "Select country"
          },
          "BIO": {
            "PLACEHOLDER": "Enter the bio"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "Zadejte název společnosti"
          }
        },
        "UPDATE_BUTTON": "Update contact",
        "SUCCESS_MESSAGE": "Contact updated successfully",
        "ERROR_MESSAGE": "Unable to update contact. Please try again later."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "Edit social links",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "Add Facebook"
          },
          "GITHUB": {
            "PLACEHOLDER": "Add Github"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "Add Instagram"
          },
          "TELEGRAM": {
            "PLACEHOLDER": "Add Telegram"
          },
          "TIKTOK": {
            "PLACEHOLDER": "Add TikTok"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "Add LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "Add Twitter"
          }
        }
      },
      "DELETE_CONTACT": {
        "MESSAGE": "This action is permanent and irreversible.",
        "BUTTON": "Delete now"
      }
    },
    "DETAILS": {
      "CREATED_AT": "Created {date}",
      "LAST_ACTIVITY": "Last active {date}",
      "DELETE_CONTACT_DESCRIPTION": "Permanently delete this contact. This action is irreversible",
      "DELETE_CONTACT": "Delete contact",
      "DELETE_DIALOG": {
        "TITLE": "Potvrdit odstranění",
        "DESCRIPTION": "Are you sure you want to delete this contact?",
        "CONFIRM": "Ano, odstranit",
        "API": {
          "SUCCESS_MESSAGE": "Contact deleted successfully",
          "ERROR_MESSAGE": "Could not delete contact. Please try again later."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "Could not upload avatar. Please try again later.",
          "SUCCESS_MESSAGE": "Avatar uploaded successfully"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "Avatar deleted successfully",
          "ERROR_MESSAGE": "Could not delete avatar. Please try again later."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "Attributes",
        "HISTORY": "History",
        "NOTES": "Notes",
        "MERGE": "Merge"
      },
      "HISTORY": {
        "EMPTY_STATE": "K tomuto kontaktu nejsou přiřazeny žádné předchozí konverzace"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Search for attributes",
        "UNUSED_ATTRIBUTES": "{count} Used attribute | {count} Unused attributes",
        "EMPTY_STATE": "There are no contact custom attributes available in this account. You can create a custom attribute in settings.",
        "YES": "Ano",
        "NO": "Ne",
        "TRIGGER": {
          "SELECT": "Select value",
          "INPUT": "Enter value"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "Invalid number",
          "REQUIRED": "Valid value is required",
          "INVALID_INPUT": "Invalid input",
          "INVALID_URL": "Invalid URL",
          "INVALID_DATE": "Invalid date"
        },
        "NO_ATTRIBUTES": "Nebyly nalezeny žádné atributy",
        "API": {
          "SUCCESS_MESSAGE": "Atribut byl úspěšně aktualizován",
          "DELETE_SUCCESS_MESSAGE": "Atribut byl úspěšně odstraněn",
          "UPDATE_ERROR": "Atribut nelze aktualizovat. Zkuste to prosím později",
          "DELETE_ERROR": "Atribut nelze odstranit. Zkuste to prosím později"
        }
      },
      "MERGE": {
        "TITLE": "Merge contact",
        "DESCRIPTION": "Combine two profiles into one, including all attributes and conversations. In case of conflict, the primary contact’s attributes will take precedence.",
        "PRIMARY": "Primary contact",
        "PRIMARY_HELP_LABEL": "To be saved",
        "PRIMARY_REQUIRED_ERROR": "Please select a contact to merge with before proceeding",
        "PARENT": "To be merged",
        "PARENT_HELP_LABEL": "To be deleted",
        "EMPTY_STATE": "No contacts found",
        "PLACEHOLDER": "Search for primary contact",
        "SEARCH_PLACEHOLDER": "Search for a contact",
        "SEARCH_ERROR_MESSAGE": "Could not search for contacts. Please try again later.",
        "SUCCESS_MESSAGE": "Contact merged successfully",
        "ERROR_MESSAGE": "Could not merge contacts, try again!",
        "IS_SEARCHING": "Searching...",
        "BUTTONS": {
          "CANCEL": "Zrušit",
          "CONFIRM": "Merge contact"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "Add a note",
        "WROTE": "wrote",
        "YOU": "Vy",
        "SAVE": "Save note",
        "ADD_NOTE": "Add contact note",
        "EXPAND": "Expand",
        "COLLAPSE": "Collapse",
        "NO_NOTES": "No notes, you can add notes from the contact details page.",
        "EMPTY_STATE": "There are no notes associated to this contact. You can add a note by typing in the box above.",
        "CONVERSATION_EMPTY_STATE": "There are no notes yet. Use the Add note button to create one."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "No contacts found in this account",
      "SUBTITLE": "Start adding new contacts by clicking on the button below",
      "BUTTON_LABEL": "Add contact",
      "SEARCH_EMPTY_STATE_TITLE": "Vašemu hledání neodpovídají žádné kontakty 🔍",
      "LIST_EMPTY_STATE_TITLE": "No contacts available in this view 📋",
      "ACTIVE_EMPTY_STATE_TITLE": "No contacts are active at the moment 🌙"
    },
    "LOAD_MORE": "Load more"
  },
  "CONTACTS_BULK_ACTIONS": {
    "ASSIGN_LABELS": "Assign Labels",
    "REMOVE_LABELS": "Remove Labels",
    "ASSIGN_LABELS_SUCCESS": "Labels assigned successfully.",
    "ASSIGN_LABELS_FAILED": "Failed to assign labels",
    "REMOVE_LABELS_SUCCESS": "Labels removed successfully.",
    "REMOVE_LABELS_FAILED": "Failed to remove labels",
    "DESCRIPTION": "Select the labels you want to add to the selected contacts.",
    "NO_LABELS_FOUND": "No labels available yet.",
    "SELECTED_COUNT": "{count} selected",
    "CLEAR_SELECTION": "Clear selection",
    "SELECT_ALL": "Select all ({count})",
    "DELETE_CONTACTS": "Vymazat",
    "DELETE_SUCCESS": "Contacts deleted successfully.",
    "DELETE_FAILED": "Failed to delete contacts.",
    "DELETE_DIALOG": {
      "TITLE": "Delete selected contacts",
      "SINGULAR_TITLE": "Delete selected contact",
      "DESCRIPTION": "This will permanently delete {count} selected contacts. This action cannot be undone.",
      "SINGULAR_DESCRIPTION": "This will permanently delete the selected contact. This action cannot be undone.",
      "CONFIRM_MULTIPLE": "Delete contacts",
      "CONFIRM_SINGLE": "Delete contact"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "We couldn’t complete the search. Please try again."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "Zobrazit",
      "SUCCESS_MESSAGE": "The message was sent successfully!",
      "ERROR_MESSAGE": "An error occurred while creating the conversation. Please try again later.",
      "NO_INBOX_ALERT": "There are no available inboxes to start a conversation with this contact.",
      "CONTACT_SELECTOR": {
        "LABEL": "Komu:",
        "TAG_INPUT_PLACEHOLDER": "Enter at least 2 characters to search by name, email, or phone number",
        "CONTACT_CREATING": "Creating contact..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "Via:",
        "BUTTON": "Show inboxes"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "Předmět :",
        "SUBJECT_PLACEHOLDER": "Enter your email subject here",
        "CC_LABEL": "Cc:",
        "CC_PLACEHOLDER": "Enter at least 2 characters to search by email",
        "BCC_LABEL": "Bcc:",
        "BCC_PLACEHOLDER": "Enter at least 2 characters to search by email",
        "BCC_BUTTON": "Bcc"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "Write your message here..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "Select template",
        "SEARCH_PLACEHOLDER": "Search templates",
        "EMPTY_STATE": "No templates found",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "WhatsApp template: {templateName}",
          "VARIABLES": "Variables",
          "BACK": "Go back",
          "SEND_MESSAGE": "Send message"
        }
      },
      "TWILIO_OPTIONS": {
        "LABEL": "Select template",
        "SEARCH_PLACEHOLDER": "Search templates",
        "EMPTY_STATE": "No templates found",
        "TEMPLATE_PARSER": {
          "BACK": "Go back",
          "SEND_MESSAGE": "Send message"
        }
      },
      "ACTION_BUTTONS": {
        "DISCARD": "Discard",
        "SEND": "Send ({keyCode})"
      }
    }
  }
}
